import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux'
import { getStore } from './../redux/store'

import ErrorBoundary from './../myjsx/components/errorBoundary'

const appStore = getStore();

global.OTUReact = {
		renderView(viewName,props,container,callback) {
			// TODO check if it is split efficiently
			import(`../myjsx/views/${viewName}`).then((view)=> {
				  console.log(`React - View ${viewName} loaded`);					
					const View = view.default;

					const element = (
						<ErrorBoundary>
							<Provider store = { appStore }>
								<View { ...props } ></View>
							</Provider>
						</ErrorBoundary>

					)

				  ReactDOM.render( element, container, function (e) {
						if (typeof callback=='function') callback();
				  });
			});

		},
		unmountContainer(container) {
			if (ReactDOM.unmountComponentAtNode(container)) {
				console.log('React - Unmounted Component');
			} else {
				console.log('React - Unmount failed, no component found for container');
			};
		}
}

